module.exports = __webpack_public_path__ + "img/logo.43178446.png";